<template>
    <div class="wrapper-card">
        <div v-if="width > 1000" class="sidenav-wrapper">
            <SideNav />
        </div>
        <div class="content-wrapper">
            <EventManageHeader
                :counterOfferData.sync="counterOfferData"
                :eventId="eventId"
                :eventDate.sync="eventDate"
                :dataUpdated.sync="dataUpdated"
            />
            <AdvancedStep
                :counterOfferData="counterOfferData"
                :eventId="eventId"
                :venueId="venueId"
                :eventDate="eventDate"
                :dataUpdated.sync="dataUpdated"
            />
        </div>
    </div>
</template>

<script>
    import AdvancedStep from './advanced-artist/AdvancedStep.vue'
    import EventManageHeader from './EventManageHeader.vue'
    import SideNav from '../../parts/SideNav.vue'
    import checkScreen from '../../../mixins/check-screen'
    export default {
        name: 'EventAdvancedPage',
        mixins: [checkScreen],
        components: {
            EventManageHeader,
            AdvancedStep,
            SideNav
        },
        props: {
            eventId: {
                type: Number
            },
            venueId: {
                type: Number
            },
            counterOfferData: {
                type: Object
            },
            dataUpdated: {
                type: Boolean
            }
        },
        data() {
            return {
                eventDate: null
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .content-wrapper {
        flex: 0 1 90%;
    }
    .wrapper-card {
        max-width: 100%;
        overflow: hidden;
    }
    .wrapper-card {
        display: flex;
        background: #000;
        align-items: flex-start;
        padding: 50px;
        gap: 58px;
    }
    @media (max-width: 1000px) {
        .wrapper-card {
            padding: 0;
            display: inline;
        }
    }
</style>
